(function() {
    function RottenTomatoRatingFormatter() {
        var score = "";
        return function(rating) {
            if (_.isNull(rating) || _.isUndefined(rating)) {
                return score;
            } else {
                switch (true) {
                    case (rating < 50):
                        score = "tomatobad.png";
                        break;
                    case (rating >= 50 && rating < 90):
                        score = "tomatookay.png";
                        break;
                    case (rating >= 90):
                        score = "tomatofresh.png";
                        break;
                }

                return score;
            }
        };
    }
    RottenTomatoRatingFormatter.$inject = [];
    angular
        .module("cstudioApp.filters")
        .filter("RottenTomatoRatingFormatter", RottenTomatoRatingFormatter);
})();